import { HttpErrorResponse } from '@angular/common/http';

import { HttpErrorInfo } from './handle-http-error';

const UPLOAD_REJECTION_FIELDS = ['size', 'virus', 'dlp'];

export const getUploadRejectionMessage = (
  error: unknown
): string | undefined => {
  if (!(error instanceof HttpErrorResponse) || error.status === 0) {
    return undefined;
  }

  const body = error.error as Partial<
    Pick<HttpErrorInfo, 'message' | 'errors'>
  >;
  const rejection = body?.errors?.find(({ field }) =>
    UPLOAD_REJECTION_FIELDS.includes(field)
  );

  return rejection?.message ?? body?.message ?? body?.errors?.[0]?.message;
};
